import { createContext, useContext } from 'react';

let context = createContext([]);
context.displayName = 'PermissionContext';

export function usePermissionContext() {
  return useContext(context);
}

export default context;
